import React from 'react'

export default function LoginIcon() {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        padding: '15px 0'
      }}
    >
      <img src='/platform/logo-login.png' width={'80%'} />
    </div>
  )
}
